export const trackersFacebookGraphApi = {
  loaded: false,
  enabled: false,

  // Load Facebook Graph API.
  // Note, if your juristiction requires prior consent before tracking technologies are used,
  // then you should have obtained consent BEFORE you call this method!
  load: function(appId, apiVersion) {
    if (!this.loaded) {
      console.log("Loading scripts and enabling Facebook Graph Api");

      // See https://developers.facebook.com/docs/javascript/quickstart
      window.fbAsyncInit = function() {
        FB.init({
          appId      : appId,
          xfbml      : true,
          version    : apiVersion
        });
      };

      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/<%= Settings.locale.split('.')[0] %>/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));

      this.loaded = true;
      this.enabled = true;
    } else {
      console.log("Facebook Graph Api scripts already loaded - re-enabling");
      // No specific way to enable/disable Graph API - just mark it as re-enabled
      this.enabled = true;
    }
  },

  // Revoke consent for Facebook Graph API
  revokeConsent: function() {
    console.log("Disabling Facebook Graph Api");
    // No specific way to enable/disable Graph API - just mark it as disabled, and don't load it on next page load
    this.enabled = false;
  }
};
